import { render, staticRenderFns } from "./Listaspromo.vue?vue&type=template&id=79979308&"
import script from "./Listaspromo.vue?vue&type=script&lang=js&"
export * from "./Listaspromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports